import { useMutation, useQueryClient, UseMutationResult } from "@tanstack/react-query";
import { authService } from "@/services/auth-service";
import { clearCommandTeamQueryCache } from "@/utils/command-query-cache";

/** Posts to /api/auth/logout (clears the httpOnly session cookies server-side) and drops cached session + command data. */
export function useLogout(): UseMutationResult<unknown, unknown, void> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => authService.logout(),
    onSuccess: () => {
      queryClient.removeQueries({ queryKey: ["auth"] });
      clearCommandTeamQueryCache(queryClient);
    },
  });
}
